export default __webpack_public_path__ + "finance_m8092f4.jpg";